<template>
  <div class="chatbot-widget">
    <!-- Panel de conversación -->
    <transition name="chatbot-fade">
      <div v-if="isOpen" class="chatbot-widget__panel">

        <!-- Header -->
        <div class="chatbot-widget__header">
          <div class="chatbot-widget__header-avatar">
            <i class="fa fa-headphones"></i>
          </div>
          <div class="chatbot-widget__header-info">
            <strong>Asistente IFF</strong>
            <span>● En línea</span>
          </div>
          <button class="chatbot-widget__header-close" @click="isOpen = false" aria-label="Cerrar chat">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Historial de mensajes -->
        <div class="chatbot-widget__messages" ref="messagesContainer">
          <div
            v-for="(msg, index) in history"
            :key="index"
            class="chatbot-widget__message"
            :class="{ 'chatbot-widget__message--user': msg.isUser }"
          >
            <div v-if="!msg.isUser" class="chatbot-widget__message-avatar">
              <i class="fa fa-headphones"></i>
            </div>
            <div class="chatbot-widget__message-bubble" v-html="renderText(msg.text)"></div>
          </div>
        </div>

        <!-- Opciones del nodo actual -->
        <div v-if="currentNode" class="chatbot-widget__options">
          <button
            v-for="(option, index) in currentNode.options"
            :key="index"
            class="chatbot-widget__option-btn"
            @click="selectOption(option)"
          >
            {{ option.label }}
          </button>
        </div>

        <!-- Reiniciar conversación -->
        <button class="chatbot-widget__restart" @click="restart">
          <i class="fa fa-refresh"></i> Reiniciar conversación
        </button>

      </div>
    </transition>

    <!-- Botón flotante de apertura -->
    <button
      class="chatbot-widget__trigger"
      @click="toggleChat"
      :aria-label="isOpen ? 'Cerrar chat' : 'Abrir chat'"
    >
      <i :class="isOpen ? 'fa fa-times' : 'fa fa-commenting'"></i>
    </button>
  </div>
</template>

<script>
import chatbotData from '@/assets/chatbot-data.json';

export default {
  name: 'ChatbotWidget',

  props: {
    startOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: this.startOpen,
      history: [],
      currentNodeKey: chatbotData.start,
      nodes: chatbotData.nodes,
    };
  },

  computed: {
    currentNode() {
      return this.nodes[this.currentNodeKey] || null;
    },
  },

  created() {
    if (this.startOpen) {
      this.pushBotMessage(this.currentNode.message);
    }
  },

  watch: {
    isOpen(val) {
      if (val && this.history.length === 0) {
        this.pushBotMessage(this.currentNode.message);
      }
    },
    history() {
      this.$nextTick(() => {
        const el = this.$refs.messagesContainer;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
  },

  methods: {
    // Convierte URLs (http/https) en enlaces clicables y preserva saltos de línea.
    // Nota: escapamos HTML antes de insertar los <a> para evitar inyección.
    renderText(text) {
      const escapeHtml = (s) =>
        s
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');

      // Evita el operador nullish coalescing (`??`) para compatibilidad del build.
      const safe = escapeHtml(String(text == null ? '' : text));

      const withLinks = safe.replace(
        /(https?:\/\/[^\s<]+)/g,
        (url) =>
          `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
      );

      return withLinks.replace(/\n/g, '<br/>');
    },

    toggleChat() {
      this.isOpen = !this.isOpen;
    },

    selectOption(option) {
      this.history.push({ text: option.label, isUser: true });
      this.currentNodeKey = option.next;
      this.$nextTick(() => {
        this.pushBotMessage(this.currentNode.message);
      });
    },

    pushBotMessage(text) {
      this.history.push({ text, isUser: false });
    },

    restart() {
      this.history = [];
      this.currentNodeKey = chatbotData.start;
      this.pushBotMessage(this.currentNode.message);
    },
  },
};
</script>

<style lang="scss" src="./ChatbotWidget.scss"></style>
